// extracted by mini-css-extract-plugin
export default {"iconSuccess":"document-upload-successfull_iconSuccess__ScYBs","buttonSuccess":"document-upload-successfull_buttonSuccess__yxrfS"};